// extracted by mini-css-extract-plugin
export default {"addressAction":"q7-z","loading":"r7-z"};